<template>
    <div class="header-box" id="header-box">
        <div class="header">
            <div class="logo">
                <img src="@/assets/images/logo.svg" alt />
            </div>

            <ul class="box-menu off-1024">
                <li :class="target === 'music' ? 'on' : ''" @click="toTarget('music')">首页</li>
                <li :class="target === 'booth' ? 'on' : ''" @click="toTarget('booth')">展区介绍</li>
                <li :class="target === 'product' ? 'on' : ''" @click="toTarget('product')">展品浏览</li>
                <li :class="target === 'schedule' ? 'on' : ''" @click="toTarget('schedule')">现场演出</li>
                <li :class="target === 'video' ? 'on' : ''" @click="toTarget('video')">视频回顾</li>
            </ul>

            <ul v-show="showMenu" class="box-menu">
                <li :class="target === 'music' ? 'on' : ''" @click="toTarget('music')">首页</li>
                <li :class="target === 'booth' ? 'on' : ''" @click="toTarget('booth')">展区介绍</li>
                <li :class="target === 'product' ? 'on' : ''" @click="toTarget('product')">展品浏览</li>
                <li :class="target === 'schedule' ? 'on' : ''" @click="toTarget('schedule')">现场演出</li>
                <li :class="target === 'video' ? 'on' : ''" @click="toTarget('video')">视频回顾</li>
            </ul>

            <div v-show="showMenu" class="btn-close" @click="switchMenu">
                <i class="remixicon-close-line"></i>
            </div>

            <div v-show="!showMenu" class="btn-menu" @click="switchMenu">
                <i class="remixicon-menu-line"></i>
            </div>

            <div v-show="!showMenu" class="box-share" :class="{ on : isShare }">
                <div class="share" @click="switchShare">
                    <i class="remixicon-share-line"></i>
                </div>
                <a href="http://service.weibo.com/share/share.php?title=雅马哈 2019 乐器展 | 收好这份指南，现场见!&url=https://www.yamaha.com.cn/2019_music_china/
&pic=https://www.yamaha.com.cn/2019_music_china/share.jpeg" target="_blank" v-show="isShare" class="weibo">
                    <i class="remixicon-weibo-fill"></i>
                </a>
                <div v-show="isShare" class="wechat" @click="showPop(true)">
                    <i class="remixicon-wechat-fill"></i>
                </div>
            </div>
        </div>
        <div v-show="popShow" class="popup pop-share" @click="showPop(false)">
            <div class="box off-1024" @click="() => {}">
                <img src="@/assets/images/qrcode.jpg" alt="" />
                <div class="btn-plus"><i class="remixicon-close-line" @click="showPop(false)"></i></div>
            </div>
            <div class="on-1024">
                <img src="@/assets/images/wx_share.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import Bus from '@/eventbus.js'
export default {
    name: "HeaderBox",
    data() {
        return {
            showMenu: false,
            target: 'music',
            isShare: false,
            popShow: false
        }
    },
    methods: {
        switchMenu() {
            this.showMenu = !this.showMenu;
            this.isShare = false
            Bus.$emit('switchMenu', this.showMenu)
        },
        switchShare() {
            this.isShare = !this.isShare
        },
        toTarget(target) {
            console.log('xxxxxxx')
            console.log(target)
            this.target = target
            if (this.showMenu) Bus.$emit('switchMenu', false)
            this.showMenu = false
            setTimeout(() => {
                this.$scrollTo('#' + target, {
                    container: '#app'
                })
            }, 10)
        },
        showPop(pop) {
            this.popShow = pop
        }
    },
    mounted() {
        Bus.$on('scrollHeader', (target) => {
            this.target = target
        })
    }
};
</script>

<style scoped lang="scss">
@import "@/styles/components/variable.scss";

// body {
//     padding-top: 70px;
// }

.header-box {
    background: rgba(0,0,0,.5);
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 12;
}

.header {
    width: 1280px;
    max-width: 100%;
    height: 70px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    // background-color: pink;
}

.logo {
    width: 140px;
    margin-left: 20px;

    img {
        max-width: 100%;
    }
}

.box-menu {
    width: 900px;
    max-width: 100%;
    display: flex;
    justify-content: space-between;
    height: 100%;

    li {
        padding: 0 45px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border-bottom: 5px solid transparent;
        color: #fff;
        cursor: pointer;
        font-size: 14px;

        &.on,
        &:hover {
            border-color: $purple;
        }
    }
}

.box-share {
    position: absolute;
    top: 15px;
    right: 15px;
    background-color: #260f3c;
    border-radius: 5px;
    // overflow: hidden;

    & > * {
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-radius: 5px;

        &:hover, &.share {
            background-color: #4b1e78;
        }
    }

    &.on {
        & > div {
            display: flex;
        }
    }

    i {
        color: #fff;
        // font-size: 20px;
    }
}

@media all and (max-width: 1024px) {



    .header-box {
        justify-content: center;
        

        i {
            color: #fff;
            font-size: 5vw;
        }
    }

    .header {
        height: 13vw;
    }

    .logo {
        width: 26%;
    }

    .box-menu {
        // display: none;
        height: auto;
        position: absolute;
        top: 13vw;
        flex-direction: column;
        width: 100%;
        z-index: 3;
        border-top: 1px solid #888;

        li {
            color: #ccc;
            background-color: #000;
            margin: 0;

            justify-content: center;
            font-size: 3.125vw;
            border-bottom: 1px dotted #333;
            padding: 4% 0;
            color: #ccc;

            &.on,
            &:hover {
                border-color: #333;
            }
        }
    }

    .btn-menu,
    .btn-close,
    .btn-share {
        position: absolute;
    }

    .btn-menu {
        color: #fff;
        right: 17%;

        i {
            // font-size: 26px;
        }
    }

    .box-share {
        width: 8vw;
        height: 8vw;
        background-color: transparent;
        top: auto;
        position: relative;

        & > * {
            width: 8vw;
            height: 8vw;
            display: none;

            &.share {
                display: flex;
            }

            &.weibo, &.wechat {
                position: absolute;
            }

            &.weibo {
                top: 8vw;
            }

            &.wechat {
                top: 16vw;
            }
        }

        &.on {
            background-color: #260f3c;

            & > * {
                display: flex;
            }
        }
    }

    .box-share,
    .btn-close {
        right: 6%;
    }
}


@media all and (max-width: 768px) {


.box-share {
    &>* {
        // padding: 14%;

        &:hover, &.share {
            background-color: transparent;
        }

        &+div {
            // margin-top: 1vw;
        }
    }

}


}
</style>